<template>
  <!-- The metric-reading popover a story beat's "Metric" chip opens: each tracked metric's value
       as-of that meeting, vs its expected-by-now / year-end target. Teleported + click-outside to
       dismiss. The host builds `popup` (data + position) via buildMetricPopup. -->
  <teleport to="body">
    <div v-if="popup" class="fixed inset-0 z-40" @click="$emit('close')"></div>
    <div
      v-if="popup"
      class="fixed z-50 w-72 rounded-lg border border-gray-200 bg-white shadow-xl p-3"
      :style="{ left: popup.left + 'px', top: popup.top + 'px' }"
    >
      <div class="flex items-center gap-1.5 mb-1.5">
        <span class="w-2 h-2 rounded-full" :style="{ background: popup.hex }"></span>
        <span class="text-xs font-semibold text-gray-700 truncate">{{ popup.title }}</span>
        <span class="text-[10px] text-gray-400 ml-auto shrink-0">{{ formatDate(popup.date) }}</span>
      </div>
      <div v-for="(m, i) in popup.metrics" :key="i" class="py-1.5 border-t border-gray-100 first:border-t-0">
        <div class="text-[11px] text-gray-500 leading-tight">{{ m.name }}</div>
        <div class="flex items-baseline gap-2 mt-0.5">
          <span class="text-lg font-bold text-gray-900 leading-none">{{ fmtRate(m.rate) }}</span>
          <span v-if="m.numerator != null && m.denominator" class="text-[11px] text-gray-400">{{ round(m.numerator) }} of {{ round(m.denominator) }}</span>
          <span v-if="m.pace" class="text-[10px] font-semibold ml-auto px-1.5 py-0.5 rounded-full" :style="{ background: paceTint(m.pace), color: paceHex(m.pace) }">{{ paceLabel(m.pace) }}</span>
        </div>
        <div class="flex flex-wrap gap-x-3 gap-y-0.5 mt-1 text-[10px] text-gray-500">
          <span v-if="m.expected != null">expected by now {{ fmtRate(m.expected) }}</span>
          <span v-if="m.target != null">year-end target {{ fmtRate(m.target) }}</span>
          <span v-if="m.rate_efctv != null && m.rate != null && Math.abs(m.rate - m.rate_efctv) > 0.0005">YoY {{ signed(m.rate - m.rate_efctv) }}</span>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import { HEALTH, NEUTRAL, fmt } from "@/components/EngagementTracker/engagementTrackerHelpers.js";

export default {
  name: "ET_MetricBeatPopup",
  props: {
    // { title, hex, date, metrics: [...], left, top } or null.
    popup: { type: Object, default: null },
  },
  emits: ["close"],
  methods: {
    fmtRate: fmt.fmtRate,
    formatDate: fmt.formatDate,
    round: (v) => Math.round(v).toLocaleString(),
    paceLabel(p) {
      return (HEALTH[p] || {}).pace || "";
    },
    paceHex(p) {
      return (HEALTH[p] || NEUTRAL).hex;
    },
    paceTint(p) {
      return (HEALTH[p] || NEUTRAL).tint;
    },
    signed(v) {
      return v == null ? "—" : (v >= 0 ? "+" : "−") + (Math.abs(v) * 100).toFixed(1) + "%";
    },
  },
};
</script>
